import useTranslation from "next-translate/useTranslation";
import { Flex, Box, Text } from "rebass/styled-components";
import { Icon, Button } from "../common";
import { Radio, Label } from "@rebass/forms/styled-components";
import { useState } from "react";
import { pushRoute } from "../../lib/routing";

const ServiceOption = ({
  icon,
  label,
  ...props
}: {
  icon: string;
  label: string;
  [x: string]: any;
}) => (
  <Flex alignItems="center">
    <Box
      mx="auto"
      px={4}
      pb={4}
      pt={[4, 0]}
      sx={{ "> *": { color: "aquamarine" } }}
    >
      <Label
        fontSize={2}
        sx={{
          cursor: "pointer",
          display: "block !important",
          color: "labradorBlack"
        }}
        data-test={props.test}
      >
        <Box
          as="i"
          fontSize={64}
          sx={{
            svg: {
              display: "block",
              marginLeft: "auto",
              marginRight: "auto"
            }
          }}
        >
          <Icon name={icon} color="aquamarine" />
        </Box>
        <Radio mx="auto" mt={2} name="sitter" {...props} />
        {label}
      </Label>
    </Box>
  </Flex>
);

interface Props {
  types: { [type: string]: string };
}

const AccountType = ({ types }: Props) => {
  const { t } = useTranslation("signup");
  const [state, setState] = useState(types.user);

  return (
    <Box
      mx="auto"
      py={[2, 3]}
      variant="box"
      sx={{
        width: "100%"
      }}
    >
      <Flex flexWrap="wrap">
        <Box width={1}>
          <Text as="h1" variant="text.h2" mb={4} sx={{ textAlign: "center" }}>
            {t("whatsYourStory")}
          </Text>
        </Box>
        <Box
          width={[1, 1 / 2]}
          sx={{
            borderRight: [0, "2px solid"],
            borderBottom: ["1px solid", 0],
            borderColor: ["gray", "gray"]
          }}
        >
          <ServiceOption
            onClick={({ target }) => setState(target.value)}
            icon={"dog"}
            label={t("imDogOwner")}
            value={types.user}
            test="user"
            defaultChecked
          />
        </Box>
        <Box width={[1, 1 / 2]}>
          <ServiceOption
            icon={"human"}
            label={t("becomeDogSitter")}
            value={types.caregiver}
            onClick={({ target }) => setState(target.value)}
            test="caregiver"
          />
        </Box>
        <Box width={[1, "16.66666vw"]} mx="auto" mt={3}>
          <Button
            width={1}
            textAlign="center"
            size="large"
            type="submit"
            data-test="continue"
            onClick={() => {
              pushRoute({ pathname: "/signup", search: { type: state } });
            }}
          >
            {t("continue")}
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default AccountType;
